import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=28a30df2&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=28a30df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a30df2",
  null
  
)

export default component.exports